export const getFilters = s => s.charity.get('filters')?.toJS();
export const getCharity = s => s.charity.get('charity').toJS();
export const getCharityLoading = s => s.charity.get('charityLoading');
